"use client";
import Button from "@/components/Button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { useUserContext } from "@/context/UserContext";
import { useZendeskChat } from "@/hooks/useZendesk";
import { ChatBubbleLeftIcon } from "@heroicons/react/24/solid";
import { ExternalLinkIcon, MailIcon } from "lucide-react";
import { Fragment, useMemo } from "react";
import { createPortal } from "react-dom";
import { Trans } from "react-i18next";
import useSWR from "swr";

function ZendeskChat() {
  useZendeskChat({
    defer: true,
    zendeskKey: "4b27aa03-d3da-43eb-8382-660c054fbc9d",
    onLoaded: () => {},
  });

  return <Fragment />;
}

export default function SupportChat() {
  const { user, status } = useUserContext();
  const { data: subscription } = useSWR(
    status === "unauthorized" ? "/subscriptions" : null
  );

  const showZendesk = useMemo(() => {
    if (status === "unauthorized") {
      const freeSubs = subscription.data?.find((m) => m.free);
      return freeSubs?.config?.live_chat;
    }
    return user?.user_subscription?.subscription?.config?.live_chat;
  }, [user, subscription]);

  if (status === "loading") {
    return <Fragment />;
  }

  if (showZendesk) {
    return <ZendeskChat />;
  }

  if (typeof window !== "undefined") {
    return createPortal(
      <div className="right-4 bottom-4 z-50 fixed dummy-chat">
        <Popover>
          <PopoverTrigger asChild>
            <button className="flex justify-center items-center bg-primary rounded-full size-16 text-white">
              <ChatBubbleLeftIcon className="size-7" />
            </button>
          </PopoverTrigger>
          <PopoverContent
            side="top"
            align="end"
            sideOffset={10}
            className="p-4"
          >
            <h2 className="font-bold">
              <Trans i18nKey="helpdesk_support" ns="common" />
            </h2>
            <p>
              <Trans i18nKey="contact_helpdesk_message" ns="common" />
            </p>
            <div className="flex flex-col gap-2 mt-3">
              <a href="mailto:helpdesk@s.id">
                <Button variant="secondary" className="justify-start w-full">
                  <MailIcon /> helpdesk@s.id
                </Button>
              </a>

              <a
                href="http://s.id/help"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button variant="outline" className="justify-start w-full">
                  <ExternalLinkIcon />
                  <Trans i18nKey="visit_support_page" ns="common" />
                </Button>
              </a>
            </div>
          </PopoverContent>
        </Popover>
      </div>,
      document.body
    );
  }
  return <Fragment />;
}
